import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function Timeline({ events = [] }) {
  return (
    <div className="space-y-0" data-testid="work-order-timeline">
      {events.map((e, i) => (
        <div key={i} className="flex gap-4 relative pb-6 last:pb-0">
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 rounded-full bg-[#0B192C] flex items-center justify-center shrink-0 z-10">
              <CheckCircle2 className="w-4 h-4 text-sunburst" />
            </div>
            {i !== events.length - 1 && (
              <div className="w-0.5 flex-1 bg-slate-200 absolute top-8 bottom-0 left-4" />
            )}
          </div>
          <div className="pt-1">
            <p className="text-sm font-semibold text-slate-800">{e.event}</p>
            <p className="text-xs text-slate-400 font-mono mt-0.5">
              {e.actor} · {new Date(e.at).toLocaleString()}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
